import {DropdownSelectData} from "app/Interface/Component/Form"
import {InputDropdownDataObject} from "app/Interface/Component/FormDropdown"
import {TBootstrapColors} from "app/WebView/Toolbar/ToolbarView.model"
import cls from "classnames"
import React, {Fragment, ReactElement, useEffect, useState} from "react"
import {Dropdown} from "react-bootstrap"
import {AlignType} from "react-bootstrap/types"
import {strToId} from "utils/ObjectStringToId"

interface DropdownNavigationProps {
  id: string
  title: string | undefined
  options: DropdownSelectData[] | InputDropdownDataObject
  onChange: (select: DropdownSelectData) => void
  direction?: AlignType
  variant?: TBootstrapColors
}

function DropdownNavigation({id, title, options, onChange, direction, variant}: DropdownNavigationProps) {

  const [hasOptions, setHasOptions] = useState(false)

  useEffect(() => {
    let hasOptions = false
    if (options) {
      if (Array.isArray(options)) {
        if (options.length > 0)
          hasOptions = true
      } else {
        Object.keys(options).map(key => {
          if (options[key].length > 0)
            hasOptions = true
        })
      }
    }
    setHasOptions(hasOptions)
  }, [options])

  const DropdownStyle = {
    display: 'flex',
  }

  return (
    <Dropdown align={direction} style={DropdownStyle}>
      <Dropdown.Toggle variant={variant ?? 'secondary'} className={cls({'hide-carrot': !hasOptions})} id={id}>
        {title}
      </Dropdown.Toggle>
      {!hasOptions ? null : (
        <Dropdown.Menu id={`${id}-list`}>
          <InputRender
            id={id}
            title={title}
            options={options}
            onChange={onChange}
            variant={variant}
            direction={direction}
          />
        </Dropdown.Menu>
      )}
    </Dropdown>
  )
}

export default DropdownNavigation

function InputRender({id, options, onChange, ...props}: DropdownNavigationProps) {
  if (Array.isArray(options))
    return (
      <InputDropdownArray
        id={id}
        options={options}
        onChange={onChange}
        {...props}
      />
    )
  else
    return (
      <InputDropdownObject
        id={id}
        options={options}
        onChange={onChange}
        {...props}
      />
    )
}

function InputDropdownObject({id, options, onChange, ...props}: DropdownNavigationProps) {
  const opt = options as InputDropdownDataObject
  const keys = Object.keys(opt)
  const items: ReactElement[] = []
  keys.map((key, index) => {
    if (opt[key].length < 1) return
    items.push(
      <Fragment key={key}>
        <InputDropdownArray
          key={key}
          id={id}
          options={opt[key]}
          onChange={onChange}
          {...props}
        />
        {index < (keys.length - 1) && <div className="dropdown-divider"/>}
      </Fragment>
    )
  })
  return (
    <>
      {items.map(i => i)}
    </>
  )
}

function InputDropdownArray({id, options, onChange}: DropdownNavigationProps) {
  return undefined === options || !Array.isArray(options) ? null : (
    <>
      {options.map(o => {
        return (
          <Dropdown.Item
            key={o.id}
            id={`${id}-${strToId(o.name)}`}
            onClick={() => onChange({...o, active: true})}
            className={cls({'active': o.active})}
          >
            {o.name}
          </Dropdown.Item>
        )
      })}
    </>
  )
}
